import { SVGProps } from 'react'

export const FullScreenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#00A4FF" />
    <g clipPath="url(#clip0_12345)">
      <path
        d="M15 13H12V17M25 13H28V17M15 27H12V23M25 27H28V23"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12345">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
)
